var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('resumo-padrao',{ref:"resumo",attrs:{"vlr-registro":_vm.vlrRegistro}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }